import React, { useRef, useState } from "react";
import { Box, Button, Checkbox, FormControlLabel, Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface FileUploadFormProps {
    setSelectedFile: React.Dispatch<React.SetStateAction<File | null>>;
    setFieldValue?: (field: string, value: any, shouldValidate?: boolean) => void;
}

const FileUploadForm: React.FC<FileUploadFormProps> = ({ setSelectedFile, setFieldValue }) => {
    const { t } = useTranslation();
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [fileName, setFileName] = useState<string | null>(null);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            setFileName(file.name);
            setSelectedFile(file);

            // If setFieldValue is provided (Formik integration), update the field value
            if (setFieldValue) {
                setFieldValue("resume", file);
            }
        }
    };

    const handleBrowseClick = () => {
        fileInputRef.current?.click();
    };


    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap:1.5,
                width: "100%",
                // mt: 2
            }}
        >
            {/* Label */}
            {/* <Typography variant="subtitle1" fontWeight="bold">
                {t("application.resume")}<span style={{ color: "#000" }}>*</span>
            </Typography> */}
             <label htmlFor="message" className="text-area-label">
             Resume*
                </label>

            {/* File Upload Container */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #A0A0A0",
                    borderRadius: "10px",
                    overflow: "hidden",
                    height: "55px",
                }}
            >
                <Box
                    sx={{
                        flexGrow: 1,
                        padding: "10px",
                        color: fileName ? "#000" : "#888",
                        fontSize: "14px",
                        borderRight: "1px solid #ddd",
                        cursor: "pointer",
                    }}
                    onClick={handleBrowseClick}
                >
                    {fileName || t("application.chooseFile")}
                </Box>

                <Button
                    variant="contained"
                    sx={{
                        borderRadius: "10px !important",
                        boxShadow: "none",
                        padding: "10px 20px",
                        textTransform: "none",
                        height: "60px",
                        width: "200px",
                        backgroundColor: "#EAECEF !important",
                        border: "1px solid #741374",
                        background:"#741374 !important",
                        color:"white "
                    }}
                    onClick={handleBrowseClick}
                >

                    {t("application.browse")}
                </Button>

                {/* Hidden File Input */}
                <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                    accept=".pdf,.doc,.docx"

                />
            </Box>

            {/* Checkbox with Terms */}
            <FormControlLabel
                control={<Checkbox />}
                label={
                    <Typography variant="body2">
                        {t("application.agreeToTerms")}{" "}
                        <Link href="#" color="#000">
                            {t("application.termsAndConditions")}
                        </Link>{" "}
                        &{" "}
                        <Link href="#" color="#000">
                            {t("application.privacyPolicy")}
                        </Link>
                    </Typography>
                }
            />
        </Box>
    );
};

export default FileUploadForm;
